export const EN_MESSAGES = {
  // Global
  lang_label: 'Language',
  lang_english: 'English',
  lang_spanish: 'Español',
  lang_french: 'Français',
  lang_arabic: 'العربية',
  lang_chinese_simplified: '中文（简体）',
  lang_german: 'Deutsch',
  lang_portuguese: 'Português',
  label_custom: 'Custom',

  // Shared navigation
  nav_features: 'Features',
  nav_sizes: 'Sizes',
  nav_how: 'How it works',
  nav_about: 'About',
  nav_privacy: 'Privacy',
  nav_faq: 'FAQ',
  nav_contact: 'Contact',
  nav_blog: 'Blog',
  nav_guide: 'Guide',
  nav_other_services: 'Other services',
  nav_background_removal: 'Free background remover',
  nav_support: 'Support Us',

  // Buttons
  btn_open_app: 'Open app',
  btn_launch_passlens: 'Launch Passlens',
  btn_explore_features: 'Explore features',
  btn_cancel: 'Cancel',
  btn_clear: 'Clear',
  btn_back: 'Back',
  btn_continue: 'Continue',
  btn_continue_to_edit: 'Continue to Edit',
  btn_continue_to_print_layout: 'Continue to Print Layout',
  btn_save: 'Save',
  btn_update: 'Update',
  btn_skip: 'Skip',
  btn_reset: 'Reset',
  btn_download_png: 'Download PNG',
  btn_download_jpeg: 'Download JPEG',
  btn_download_pngs_zip: 'Download PNGs (ZIP)',
  btn_download_jpegs_zip: 'Download JPEGs (ZIP)',
  btn_download_pdf: 'Download PDF',
  common_dismiss: 'Dismiss',
  app_route_loader_title: 'Opening the Passlens editor',
  app_route_loader_body:
    'Choose a document preset, add your photo, then export a digital file or a print-ready sheet. The editor runs in this browser tab.',
  app_route_loader_error_title: 'Could not load the editor',
  app_route_loader_error_body:
    'The editor is taking too long to start or one of its files failed to load. Try again.',
  app_route_loader_retry: 'Retry editor',
  app_step_loader_edit_title: 'Loading editor tools',
  app_step_loader_edit_body:
    'Preparing the editor, background tools, and compliance guidance.',
  app_step_loader_compose_title: 'Loading print layout',
  app_step_loader_compose_body:
    'Preparing paper sizes, layout controls, and export tools.',

  // Landing
  landing_nav_aria: 'Landing navigation',
  landing_feature_highlights_aria: 'Feature highlights',
  landing_feature_guides_aria: 'Feature guides',
  landing_popular_use_cases_aria: 'Popular ID photo use cases',
  landing_popular_sizes_aria: 'Popular passport photo sizes',
  landing_size_guides_aria: 'Size guides',
  landing_workflow_steps_aria: 'Workflow steps',
  landing_workflow_guides_aria: 'Workflow guides',
  landing_apps_support_aria: 'App trust and methodology',
  landing_faq_aria: 'Frequently asked questions',
  landing_badge_passport_id: 'Passport, ID & driving licence photos',
  landing_badge_verified_sizes: 'Verified sizes',
  landing_badge_no_uploads: 'No photo uploads',
  landing_badge_dpi_export: '300/600 DPI export',
  landing_badge_free_no_signup: '100% free · No signup',

  landing_hero_title: 'Passlens passport photo guides, sizes, and tools for 2x2, visa, biometric, and ID workflows.',
  landing_hero_subtitle_1:
    'Start with the guide or tool that matches the job. Check the size, print route, or upload rules first, then open the maker, checker, or 2x2 workflow when you are ready to edit.',
  landing_hero_subtitle_2:
    'Passlens keeps the workflow in one place: local-first editing, no signup, and straightforward print and pixel exports.',
  landing_stat_dpi_value: '300/600',
  landing_stat_dpi_label: 'DPI exports',
  landing_stat_scale_value: '100%',
  landing_stat_scale_label: 'Scale-ready',
  landing_stat_accounts_value: '0',
  landing_stat_accounts_label: 'Accounts needed',

  landing_hero_tab_crop: 'Crop',
  landing_hero_tab_remove_bg: 'Remove BG',
  landing_hero_tab_print_layout: 'Print Layout',
  landing_hero_sample_doc: 'US Passport',

  landing_section_why_eyebrow: 'Why Passlens',
  landing_section_why_title: 'Designed for accuracy and speed.',
  landing_section_why_body:
    'A modern workflow for anyone searching for a free passport photo maker online, a way to create a passport photo online free for a U.S. 2x2 workflow, an online passport photo editor, or a biometric photo maker — without signup and without uploading or storing your photos. Sizes include common passport formats like 2×2 in (51×51 mm), 35×45 mm, and many mm-based standards.',
  landing_feature_sizing_title: 'Preset-accurate sizing',
  landing_feature_sizing_body: 'Presets lock mm dimensions and head guidance so exports match official requirements.',
  landing_feature_tag_verified_dimensions: 'Verified dimensions',
  landing_feature_tag_auto_fit: 'Auto fit',
  landing_feature_print_title: 'Print layout engine',
  landing_feature_print_body: 'Pack copies across pages with a PDF-style preview and consistent margins.',
  landing_feature_bg_title: 'Free background remover',
  landing_feature_bg_body: 'Remove a general photo background for free, then download a transparent PNG without signup or watermark.',
  landing_feature_dpi_title: 'Real DPI exports',
  landing_feature_dpi_body: '300/600 DPI outputs are true pixel sizes — no cosmetic toggles.',

  landing_section_sizes_eyebrow: 'Sizes',
  landing_section_sizes_title: 'Passport photo sizes that print correctly.',
  landing_section_sizes_body_1:
    'Pick a document preset, crop to the right dimensions, and export files that match real paper sizes at true DPI. Common standards like 2×2 in (51×51 mm) for U.S. passport photos, 35×45 mm, and 50×70 mm are ready out of the box.',
  landing_section_sizes_body_2:
    'Need a print sheet? Compose pages on A4, Letter, 4×6, or 5×7 — then download a multi-page PDF or a ZIP of PNG pages.',
  landing_section_sizes_body_3:
    'Looking for a specific passport photo size? Search by country, document type, or size — then fine-tune rotation, zoom, margins, spacing, and background color before exporting.',
  landing_sizes_bullet_1: 'Passport photos, visa photos, national ID photos, and selected driving licence photos',
  landing_sizes_bullet_2: 'Background cleanup and color options for common requirements',
  landing_sizes_bullet_3: 'Margins and spacing that stay consistent in preview and export',

  landing_sizes_card_2x2: '51×51 mm · US-style passport photos',
  landing_sizes_card_35x45: 'Common visa & passport format',
  landing_sizes_card_50x70: 'Canada-style photo format',
  landing_sizes_card_26x32: 'Common national ID size',
  landing_sizes_card_dpi: 'Pixel-accurate exports for print',
  landing_sizes_card_multipage_title: 'Multi-page',
  landing_sizes_card_multipage_body: 'Automatic pagination when copies overflow',

  landing_section_workflow_eyebrow: 'Workflow',
  landing_section_workflow_title: 'From upload to print in three steps.',
  landing_section_workflow_body: 'A guided flow with only the controls you need at each stage.',
  landing_timeline_01_title: 'Select document type',
  landing_timeline_01_body: 'Choose from verified presets and background guidance.',
  landing_timeline_02_title: 'Edit & crop',
  landing_timeline_02_body: 'Auto fit, rotate, zoom, and remove backgrounds.',
  landing_timeline_03_title: 'Compose & export',
  landing_timeline_03_body: 'Pack pages and export PNGs or PDFs at full DPI.',

  landing_section_apps_eyebrow: 'Apps & tools',
  landing_section_apps_title: 'Passport, biometric, and ID photo makers plus validators.',
  landing_section_apps_body:
    'Open the browser app, compare passport photo makers, validators, and background-removal workflows, and use the strongest crop, upload, print, and template guides to finish the job with less guesswork. This page is for product and workflow discovery, not a mobile-app waiting list.',
  landing_apps_android_title: 'Android',
  landing_apps_android_body:
    'Camera-first workflow with on-device background cleanup. Take and edit passport photos directly on your phone.',
  landing_apps_ios_title: 'iOS',
  landing_apps_ios_body:
    'Powered by Vision framework for instant subject detection. Optimized for iPhone and iPad with native performance.',
  landing_apps_coming_soon: 'Coming soon',
  landing_apps_web_title: 'Passlens web app',
  landing_apps_web_body:
    'Open the browser editor to crop passport, visa, biometric, and ID photos, clean up the background, and export digital files or print sheets without signup.',
  landing_apps_web_badge: 'Browser app',
  landing_apps_support_about_kicker: 'Trust',
  landing_apps_support_about_title: 'About Passlens',
  landing_apps_support_about_body:
    'See what Passlens is, who it is for, and how the browser-first workflow is maintained.',
  landing_apps_support_methodology_kicker: 'Methodology',
  landing_apps_support_methodology_title: 'How Passlens verifies passport photo rules',
  landing_apps_support_methodology_body:
    'Read the source hierarchy and update workflow behind the public passport-photo guides.',

  landing_section_privacy_eyebrow: 'Privacy',
  landing_section_privacy_title: 'Your photos stay yours.',
  landing_section_privacy_body:
    'Passlens is local by default. Cropping, layout, and many edits run on your device. If you choose enhanced processing for heavier work, the image is used only for that request and then cleared.',
  landing_privacy_local_title: 'Local by default',
  landing_privacy_local_body:
    'Cropping, layout, and many edits run on your device. Enhanced processing is optional and only used when you choose it.',
  landing_privacy_no_account_title: 'No account',
  landing_privacy_no_account_body: 'Start immediately — no sign-up required. Stay local, or choose enhanced help only when you want it.',

  landing_section_faq_eyebrow: 'FAQ',
  landing_section_faq_title: 'Answers, upfront.',
  landing_section_faq_body: 'Everything you need to know before starting.',
  landing_faq_account_q: 'Do I need to create an account?',
  landing_faq_account_a: 'No. Passlens runs in your browser and doesn’t require signup.',
  landing_faq_free_q: 'Is Passlens really free?',
  landing_faq_free_a: 'Yes — 100% free, no signup, and no paywalls.',
  landing_faq_uploads_q: 'Does Passlens upload my photos?',
  landing_faq_uploads_a:
    'By default, no. Your photos stay on your device unless you explicitly choose enhanced processing for heavier work. When you do, Passlens uses the image only for that request and clears it afterward.',
  landing_faq_dpi_q: 'Is 600 DPI real?',
  landing_faq_dpi_a: 'Yes. Exports are generated at the selected DPI so pixels match the physical size.',
  landing_faq_multipage_q: 'Can I export multiple pages?',
  landing_faq_multipage_a: 'Yes. Print Layout paginates automatically and supports PDF or PNG ZIP exports.',
  landing_faq_paper_q: 'What paper sizes are supported?',
  landing_faq_paper_a: 'A4, A5, Letter, 4×6, 5×7, and custom sheet sizes are available in Print Layout.',
  landing_faq_print_q: 'How do I print at the right size?',
  landing_faq_print_a:
    'Print at 100% scale. Disable “Fit to page” or “Scale to fit” so millimeters stay true.',

  landing_section_contact_eyebrow: 'Contact',
  landing_section_contact_title: 'Questions or feedback?',
  landing_section_contact_body:
    'Send us a message and we’ll reply by email. Use Support if you’re reporting a bug or need help with a specific step.',
  landing_contact_tip_1: 'Include your document preset (country + type)',
  landing_contact_tip_2: 'Mention what device/browser you’re using',
  landing_contact_tip_3: 'Add screenshots if something looks off',

  landing_section_blog_eyebrow: 'Blog',
  landing_section_blog_title: 'Passport photo guides & tips',
  landing_section_blog_body:
    'Country-specific requirements, printing guides, background rules, and expert tips — everything you need to get your passport photo right the first time.',
  landing_blog_view_all: 'View all posts',
  landing_blog_popular_title: 'Popular searches',
  landing_blog_popular_body: 'Direct links to the passport, visa, and photo-size guides people look for most.',
  landing_blog_group_passport_title: 'Country passport guides',
  landing_blog_group_passport_body: 'Jump straight to the most searched passport markets and their exact photo rules.',
  landing_blog_group_id_title: 'ID and driving licence',
  landing_blog_group_id_body: 'Start from official ID and licence workflows, then open the exact document guide you need.',
  landing_blog_group_size_title: 'Sizes and printing',
  landing_blog_group_size_body: 'Use these when you know the format first and need the right size, DPI, or print layout.',
  seo_home_title: 'Passlens — Passport Photo Requirements, Size Guides, and Tools',
  seo_home_description:
    'Passlens helps you create passport photos online free for 2x2, visa, biometric, and ID workflows. Compare size guides, print help, and direct links to the maker, checker, and 2x2 workflow pages.',
  seo_features_title: 'Online Passport Photo Maker Features',
  seo_features_description:
    'Explore the Passlens online passport photo maker features: background cleanup, automatic face adjustment, verified passport-photo sizes, digital exports, and print-layout tools.',
  seo_sizes_title: 'Passport Photo Sizes: 2x2, 35x45, 50x70',
  seo_sizes_description:
    'Check passport photo sizes for common formats like 2x2 inch, 35x45 mm, 50x70 mm, and more. Export at true 300/600 DPI.',
  seo_how_title: 'How to Make Passport Photos Online Free',
  seo_how_description:
    'See how to use Passlens as a free passport photo maker online: choose a document, auto-fit the face, clean up the background, and export a passport-size photo or print sheet.',
  seo_apps_title: 'Passport Photo Maker, Checker, Validator, Biometric Maker, and Background Remover',
  seo_apps_description:
    'Compare passport photo makers, validators, biometric photo maker workflows, background-removal tools, upload checks, and the Passlens web app for 2x2, visa, biometric, and ID photo workflows. Built for users who want to open the app and finish the photo, not keep guessing.',
  seo_privacy_title: 'Private Passport Photo Tool',
  seo_privacy_description:
    'Passlens is local by default, with optional enhanced processing only when you choose it for heavier tasks. No signup and no hidden storage workflow.',
  seo_faq_title: 'Passport Photo Maker FAQ',
  seo_faq_description:
    'Answers about passport photo sizes, DPI, printing, privacy, and exports before you create your passport, visa, or ID photo.',
  seo_contact_title: 'Contact Passlens',
  seo_contact_description:
    'Contact Passlens for bug reports, feature requests, product feedback, source corrections, or general help with photo sizes, printing, and exports.',
  seo_terms_title: 'Passlens Terms of Service',
  seo_terms_description:
    'Read the Passlens terms for using the browser app, public guides, exports, analytics, and optional enhanced processing.',
  consent_banner_title: 'Cookie preferences',
  consent_banner_body:
    'We use cookies for analytics. No tracking without your consent.',
  consent_banner_accept: 'Accept',
  consent_banner_decline: 'Decline',
  contact_page_eyebrow: 'Contact',
  contact_page_title: 'Contact Passlens',
  contact_page_body:
    'Use this page for product help, bug reports, requirement corrections, feature requests, and general feedback. The clearer the context, the faster we can check the right preset, guide, or workflow.',
  contact_page_body_secondary:
    'If your message is about a specific preset, page, or step, say which one. That usually saves a round trip and helps us check the right workflow first.',
  contact_page_body_tertiary:
    'If a guide or requirement page looks wrong, send the official source you were reading. That is the fastest way for us to tell whether the issue is in the rule, the preset, or the wording.',
  contact_page_reasons_title: 'What you can contact us about',
  contact_page_reasons_body:
    'Choose the closest reason below, then use Contact for general messages or Support for issues tied to a specific step.',
  contact_page_reason_general_title: 'General contact',
  contact_page_reason_general_body:
    'Questions about Passlens, partnerships, media, or anything that does not fit a bug report.',
  contact_page_reason_support_title: 'Bug report or workflow help',
  contact_page_reason_support_body:
    'Something broke while cropping, exporting, printing, or using a specific preset or browser/device combination.',
  contact_page_reason_feedback_title: 'Product feedback',
  contact_page_reason_feedback_body:
    'Tell us what felt confusing, slow, or missing in the editor, guides, or print workflow.',
  contact_page_reason_feature_title: 'Feature request',
  contact_page_reason_feature_body:
    'Request a new document preset, export option, editor tool, or workflow improvement.',
  contact_page_reason_correction_title: 'Source or requirement correction',
  contact_page_reason_correction_body:
    'Flag an outdated passport, ID, or driving-licence rule and include the official authority page if you have it.',
  contact_page_split_title: 'How to route your message',
  contact_page_split_body:
    'Use the tab that best matches the job so we can triage it correctly on the first reply.',
  contact_page_split_contact_title: 'Use Contact when',
  contact_page_split_contact_body:
    'You have a general question, want to share feedback, need a source checked, or want to ask about future features.',
  contact_page_split_support_title: 'Use Support when',
  contact_page_split_support_body:
    'You are blocked by a bug, export issue, upload problem, wrong crop, broken preset, or a step that behaves differently than expected.',
  contact_page_include_title: 'What to include for a useful answer',
  contact_page_include_1: 'Country, document type, and preset name if one is involved.',
  contact_page_include_2: 'The exact page or step where the problem started.',
  contact_page_include_3: 'Your device, browser, and which processing option you were using.',
  contact_page_include_4: 'A screenshot or precise description of what you expected versus what happened.',
  contact_page_privacy_title: 'Keep sensitive data out of support messages',
  contact_page_privacy_body:
    'Do not include passport numbers, national ID numbers, payment-card details, or other identity data that is not needed to explain the issue. If you need us to review a requirement, send the official source link or a screenshot of the public instruction page instead.',
  contact_page_form_title: 'Send your message',
  contact_page_form_body:
    'The form below goes to Passlens support email. Use Contact for general questions, feedback, and source corrections. Use Support if you need help with a specific bug or workflow step.',
  contact_attachment_label: 'Attach image (optional)',
  contact_attachment_helper: 'Images only: PNG, JPG, WEBP, or GIF. Max 500 KB. Use this for screenshots or visual examples.',
  contact_attachment_selected: 'Attached image: {{name}} ({{size}})',
  contact_attachment_remove: 'Remove',
  contact_attachment_error_invalid_type: 'Only PNG, JPG, WEBP, or GIF images are allowed.',
  contact_attachment_error_too_large: 'Image attachments must be 500 KB or smaller.',
  contact_attachment_error_read: 'Could not read the selected image. Please try another file.',
  seo_guide_title: 'Online Passport Photo Maker and Validator Guide',
  seo_guide_description:
    'Step-by-step guide to using Passlens as an online passport photo maker and validator, from preset selection and digital export to print-layout sheets and final photo checks.',
  seo_app_title: 'Free Passport Photo App Online — Passlens',
  seo_app_description:
    'Open the Passlens browser app to crop passport, visa, biometric, and ID photos, clean up the background, and export a digital file or print sheet without signup.',

  // Blog pages
  blog_list_title: 'Passport Photo Requirements by Country, Size Guides, and Print Help',
  blog_list_subtitle:
    'Use the Passlens blog to compare passport photo requirements by country, 2x2 and 35x45 size rules, digital upload workflows, print settings, and retailer-specific booth guides.',
  blog_core_guides_title: 'Search-first guides',
  blog_core_guides_body:
    'Start with the trust pages and the requirement guides already closest to winning search traffic: methodology, by-country size rules, France, Max Spielmann, and digital upload help.',
  blog_core_about_title: 'About Passlens',
  blog_core_about_body:
    'What Passlens is, who it is for, and how the browser-first workflow is maintained.',
  blog_core_methodology_title: 'How Passlens verifies passport photo rules',
  blog_core_methodology_body:
    'Source hierarchy, update workflow, and where the public guides stop and official authorities take over.',
  blog_topics_title: 'Priority topics',
  blog_topics_body: 'Start with the requirement hubs Google is already testing, then move into tool, print, and country-specific workflows.',
  blog_filter_all: 'All',
  blog_filter_guides: 'Guides',
  blog_filter_tips: 'Tips',
  blog_filter_countries: 'Countries',
  blog_search_label: 'Search posts',
  blog_search_placeholder: 'Search by country, document, size, print, or software',
  blog_search_results: 'Showing {{count}} posts for "{{query}}"',
  blog_empty_search: 'No posts match "{{query}}".',
  blog_empty_category: 'No posts in this category yet.',
  blog_read_more: 'Read more →',
  blog_category_country_guide: 'Country guide',
  blog_category_guide: 'Guide',
  blog_category_tips: 'Tips',
  blog_post_updated: 'Updated {{date}}',
  blog_post_loading: 'Loading article…',
  blog_post_all_posts: '← All posts',
  blog_post_not_found_title: 'Post not found',
  blog_post_not_found_body: "The blog post you're looking for doesn't exist.",
  blog_post_back_to_blog: 'Back to blog',
  blog_post_article_sections_aria: 'Article sections',
  blog_post_site_nav_aria: 'Site navigation',
  blog_post_toc_aria: 'Table of contents',
  aria_breadcrumb: 'Breadcrumb',
  public_page_toc_back: '← Passlens',
  guide_sections_aria: 'Guide sections',
  trust_footer_links_aria: 'Trust and support links',
  blog_related_title: 'Related guides',
  blog_related_body: 'Continue with the closest passport, visa, and photo-size guides.',
  trust_link_about: 'About',
  trust_link_editorial_policy: 'Editorial policy',
  trust_link_methodology: 'Methodology',
  trust_link_privacy_policy: 'Privacy policy',
  trust_link_terms: 'Terms',

  blog_specs_requirement: 'Requirement',
  blog_specs_value: 'Value',
  blog_specs_document: 'Document',
  blog_specs_size: 'Size',
  blog_specs_background: 'Background',
  blog_specs_background_white: 'White',
  blog_specs_background_light: 'Light / neutral',
  blog_specs_head_height: 'Head height',
  blog_specs_note: 'Note',

  // Blog content i18n (post bodies)
  blog_section_overview: 'Overview',
  blog_section_size_at_glance: 'Size at a glance',
  blog_section_official_specs: 'Official specifications',
  blog_section_background: 'Background',
  blog_section_appearance: 'Appearance',
  blog_section_key_points: 'Key points',
  blog_section_with_passlens: 'How to do it with Passlens',
  blog_section_sources: 'Sources',
  blog_section_faq: 'FAQ',

  blog_with_passlens_intro: 'Create a compliant <strong>{{country}} {{doc}}</strong> photo in minutes:',
  blog_with_passlens_intro_generic: 'Create a compliant photo in minutes:',
  blog_with_passlens_step_1: 'Open Passlens and select the <strong>{{country}} {{doc}}</strong> preset.',
  blog_with_passlens_step_2: 'Upload a well-lit, front-facing portrait (no heavy filters).',
  blog_with_passlens_step_3: 'Use <strong>Auto</strong> to align the crop and straighten any tilt.',
  blog_with_passlens_step_4: 'Pick the required background and clean it up if needed.',
  blog_with_passlens_step_5: 'Export a true 300/600 DPI PNG for online use or a multi-page PDF for printing.',

  blog_doc_passport: 'Passport',
  blog_doc_visa: 'Visa',
  blog_doc_driving_licence: 'Driving Licence',
  blog_doc_national_id: 'National ID',
  blog_doc_residence_permit: 'Residence Permit',
  blog_doc_id_passport: 'ID/Passport',

  blog_country_meta_title: '{{country}} {{doc}} photo requirements ({{year}})',
  blog_country_meta_description:
    'Official {{doc}} photo size for {{country}}: {{size}}. Crop to spec, align your head, and export a compliant photo locally with Passlens.',
  blog_country_overview_p1_with_head:
    'For {{country}} {{doc}} applications, your photo should be <strong>{{size}}</strong>, with a head height of <strong>{{headRange}}</strong> (chin to crown). This guide reflects {{year}} requirements and common rejection reasons.',
  blog_country_overview_p1_no_head:
    'For {{country}} {{doc}} applications, your photo should be <strong>{{size}}</strong>. This guide reflects {{year}} requirements and common rejection reasons.',
  blog_country_overview_p2:
    'Passlens helps you crop to the correct mm dimensions and export print-ready files — everything runs locally in your browser.',
  blog_country_size_at_glance_p1:
    'For {{country}} {{doc}} applications, the target photo size is <strong>{{size}}</strong>.',
  blog_country_size_at_glance_p2_with_head:
    'Keep the head height around <strong>{{headRange}}</strong>, use a <strong>{{bg}}</strong> background, and export at true print size.',
  blog_country_size_at_glance_p2_no_head:
    'Use a <strong>{{bg}}</strong> background, keep the face centered, and export at true print size.',
  blog_country_specs_p1_with_head:
    'Use the official size <strong>{{size}}</strong>. Keep your head between <strong>{{headRange}}</strong>, centered, and use a <strong>{{bg}}</strong> background.',
  blog_country_specs_p1_no_head:
    'Use the official size <strong>{{size}}</strong>, keep your face centered, and use a <strong>{{bg}}</strong> background.',
  blog_country_background_p1_with_note: 'Background must be <strong>{{bg}}</strong>. <em>{{bgNote}}</em>',
  blog_country_background_p1_no_note: 'Background must be <strong>{{bg}}</strong>.',
  blog_country_appearance_intro:
    'Most authorities follow ICAO-style biometric rules. These basics usually prevent rejections:',
  blog_country_appearance_item_expression: '<strong>Expression:</strong> Neutral, mouth closed.',
  blog_country_appearance_item_eyes: '<strong>Eyes:</strong> Both eyes open and visible; avoid hair covering your eyes.',
  blog_country_appearance_item_glasses:
    '<strong>Glasses:</strong> Avoid if possible; if allowed, no glare and frames must not cover eyes.',
  blog_country_appearance_item_headwear:
    '<strong>Head coverings:</strong> Only if required for religious/medical reasons; full face must be visible.',
  blog_country_appearance_item_lighting:
    '<strong>Lighting:</strong> Even lighting, no shadows on face or background.',
  blog_country_sources_intro: 'We verify preset dimensions using official sources. Links:',
  blog_country_faq_q_home: 'Can I take my own photo at home?',
  blog_country_faq_a_home:
    'Yes — as long as the photo meets size, lighting, and background rules. Use Passlens to crop, align, and export at true DPI.',
  blog_country_faq_q_background: 'What background do I need?',
  blog_country_faq_a_background_with_note: 'Use a <strong>{{bg}}</strong> background. {{bgNote}}',
  blog_country_faq_a_background_no_note: 'Use a <strong>{{bg}}</strong> background.',
  blog_country_faq_q_privacy: 'Does Passlens upload my photo?',
  blog_country_faq_a_privacy:
    'By default, no. Passlens processes your photo on your device unless you choose enhanced processing for heavier work. If you use that option, the image is used only for that request and then cleared.',

  blog_general_passport_photo_size_guide_title: "Passport Photo Size Guide: Every Country's Requirements in 2026",
  blog_general_passport_photo_size_guide_description:
    "Complete reference for passport photo dimensions worldwide. Compare 2x2 inch, 35x45mm, 50x70mm, and other sizes with official specs for the US, UK, Canada, Spain, Hong Kong, and Turkey.",
  blog_general_passport_photo_size_guide_overview_p1:
    'Passport photo sizes vary by country and document. Even a 1–2 mm mismatch can cause a rejection — especially for printed submissions.',
  blog_general_passport_photo_size_guide_overview_p2:
    'Passlens presets lock the correct mm dimensions and head guidance, so you can export files that print at true size.',
  blog_general_passport_photo_size_guide_k1:
    'Common sizes include <strong>51×51 mm (2×2 in)</strong>, <strong>35×45 mm</strong>, and <strong>50×70 mm</strong>.',
  blog_general_passport_photo_size_guide_k2:
    'Some countries use different sizes for passports vs national IDs and visas — pick the exact preset.',
  blog_general_passport_photo_size_guide_k3:
    'Head size rules (chin-to-crown) can be as important as the outer dimensions.',
  blog_general_passport_photo_size_guide_k4:
    'Export at true 300/600 DPI and print at 100% scale.',

  blog_general_how_to_print_passport_photos_title:
    'How to Print Passport Photos at Home: Paper, DPI, and Printer Settings',
  blog_general_how_to_print_passport_photos_description:
    'Learn how to print passport photos at home with the correct size, DPI, paper type, and printer settings. Avoid common mistakes that cause application rejections.',
  blog_general_how_to_print_passport_photos_overview_p1:
    'Printing at home can work great, but most size problems come from printer scaling, paper choice, and DPI mismatches.',
  blog_general_how_to_print_passport_photos_overview_p2:
    'With Passlens, you can generate a print sheet with consistent margins and download a multi-page PDF or PNG pages.',
  blog_general_how_to_print_passport_photos_k1:
    'Always print at <strong>100% scale</strong> (disable “Fit to page”).',
  blog_general_how_to_print_passport_photos_k2:
    'Use photo paper when possible, and let ink dry before cutting.',
  blog_general_how_to_print_passport_photos_k3:
    'Pick 300 DPI for most printers; use 600 DPI for crisp edges and better cutting accuracy.',
  blog_general_how_to_print_passport_photos_k4:
    'Measure a printed copy with a ruler before submitting.',

  blog_general_passport_photo_2x2_size_title:
    '2x2 Picture Size 2026: 2 by 2 Passport Photo Dimensions in Inches, cm, mm, and Pixels',
  blog_general_passport_photo_2x2_size_description:
    'Fast 2x2 picture size answers: 2 inches by 2 inches, 5.08 x 5.08 cm, about 51 x 51 mm, 600x600 pixels at 300 DPI, and when 2x2 is passport size.',
  blog_general_passport_photo_2x2_size_overview_p1:
    '2x2 inches is the standard square passport photo format for US-style passport and visa workflows.',
  blog_general_passport_photo_2x2_size_overview_p2:
    'The outer frame matters, but face height and print scaling are what usually cause rejections.',
  blog_general_passport_photo_2x2_size_k1:
    '2x2 inches is about <strong>51×51 mm</strong>.',
  blog_general_passport_photo_2x2_size_k2:
    'At 300 DPI, a 2x2 photo is typically <strong>600×600 px</strong>.',
  blog_general_passport_photo_2x2_size_k3:
    'US-style 2x2 photos often need a head height around <strong>25–35 mm</strong>.',
  blog_general_passport_photo_2x2_size_k4:
    'Always print at 100% scale and verify one sample with a ruler.',

  blog_general_photo_size_35x45_title:
    '35x45 Photo Size Guide: Passport, Visa, and ID Requirements (2026)',
  blog_general_photo_size_35x45_description:
    'Learn where 35x45 photo size is used for passport, visa, and ID applications. Includes dimensions in mm and inches, pixel sizes at 300/600 DPI, and common country-specific differences.',
  blog_general_photo_size_35x45_overview_p1:
    '35×45 mm is one of the most common biometric photo sizes worldwide, especially across Europe and parts of Asia.',
  blog_general_photo_size_35x45_overview_p2:
    'Countries may share the same outer size while still using different rules for head height, background, and uploads.',
  blog_general_photo_size_35x45_k1:
    '35×45 mm is about <strong>1.38×1.77 inches</strong>.',
  blog_general_photo_size_35x45_k2:
    'At 300 DPI, the common digital target is about <strong>413×531 px</strong>.',
  blog_general_photo_size_35x45_k3:
    'Do not assume every 35×45 country accepts the same background color or face position.',
  blog_general_photo_size_35x45_k4:
    'Choose the exact country/document preset instead of making a generic 35×45 crop.',

  blog_general_passport_photo_50x70_size_title:
    '50x70 Passport Photo Size: Canada Passport and Visa Requirements (2026)',
  blog_general_passport_photo_50x70_size_description:
    'Understand 50x70 passport photo size for Canada and similar applications. Learn the exact dimensions, pixel sizes at 300/600 DPI, head-height rules, and print tips for compliant photo submissions.',
  blog_general_passport_photo_50x70_size_overview_p1:
    '50×70 mm is best known as the Canadian passport photo size and is larger than the common 35×45 format.',
  blog_general_passport_photo_50x70_size_overview_p2:
    'To get it right, you need both the exact outer frame and the correct face height inside the photo.',
  blog_general_passport_photo_50x70_size_k1:
    '50×70 mm is about <strong>1.97×2.76 inches</strong>.',
  blog_general_passport_photo_50x70_size_k2:
    'At 300 DPI, a 50×70 photo is roughly <strong>591×827 px</strong>.',
  blog_general_passport_photo_50x70_size_k3:
    'Canadian passport photos commonly require a face height around <strong>31–36 mm</strong>.',
  blog_general_passport_photo_50x70_size_k4:
    'Measure both the print size and the head height before submitting.',

  blog_general_passport_photo_size_in_pixels_title:
    'Passport Photo Size in Pixels: 2x2, 35x45, 50x70, and 300 DPI Conversions (2026)',
  blog_general_passport_photo_size_in_pixels_description:
    'Find passport photo size in pixels for common formats like 2x2 inch, 35x45 mm, and 50x70 mm. Includes 300 DPI and 600 DPI conversions for digital uploads and print-ready exports.',
  blog_general_passport_photo_size_in_pixels_overview_p1:
    'Digital passport and visa forms often validate pixel dimensions before anything else.',
  blog_general_passport_photo_size_in_pixels_overview_p2:
    'The right pixel size depends on the physical dimensions of the photo and the export DPI.',
  blog_general_passport_photo_size_in_pixels_k1:
    '<strong>2x2 in</strong> is commonly <strong>600×600 px</strong> at 300 DPI.',
  blog_general_passport_photo_size_in_pixels_k2:
    '<strong>35×45 mm</strong> is about <strong>413×531 px</strong> at 300 DPI.',
  blog_general_passport_photo_size_in_pixels_k3:
    '<strong>50×70 mm</strong> is about <strong>591×827 px</strong> at 300 DPI.',
  blog_general_passport_photo_size_in_pixels_k4:
    'Pixels alone are not enough: head size, background, and file-size limits still matter.',

  blog_general_passport_photo_background_color_title:
    'Passport Photo Background Color Guide: White, Grey, Blue, and What Each Country Allows (2026)',
  blog_general_passport_photo_background_color_description:
    'Learn which passport photo background colors are accepted for passport, visa, and ID photos. Compare white, grey, and blue background rules and avoid common rejection mistakes.',
  blog_general_passport_photo_background_color_overview_p1:
    'There is no single global passport photo background color rule. Some documents want white, others prefer a very light neutral background.',
  blog_general_passport_photo_background_color_overview_p2:
    'Even when the color is right, shadows, texture, and poor cleanup can still cause rejection.',
  blog_general_passport_photo_background_color_k1:
    'White backgrounds are common, but not universal.',
  blog_general_passport_photo_background_color_k2:
    'Light grey is common in biometric workflows and some UK/EU-style documents.',
  blog_general_passport_photo_background_color_k3:
    'Some French-style document photos prefer a light blue or blue-grey tone instead of pure white.',
  blog_general_passport_photo_background_color_k4:
    'Choose the exact country/document preset before editing the background.',

  blog_general_passport_photo_background_rules_title:
    'Passport Photo Background Rules: White, Grey, Blue, and Country-Specific Requirements',
  blog_general_passport_photo_background_rules_description:
    'Not every country wants a white background. Learn the specific background color rules for passport photos in the US, UK, France, Germany, and more. Includes tips for background removal.',
  blog_general_passport_photo_background_rules_overview_p1:
    'Not every country wants a pure white background — some require light gray or light blue, and shadows can cause rejections.',
  blog_general_passport_photo_background_rules_overview_p2:
    'Passlens can set a compliant background color and help you clean up uneven backdrops without uploading your photo.',
  blog_general_passport_photo_background_rules_k1:
    'Use an even, shadow-free background with good contrast against hair.',
  blog_general_passport_photo_background_rules_k2:
    'Avoid patterned walls, textured fabric, and visible corners/objects.',
  blog_general_passport_photo_background_rules_k3:
    'Check the preset note for countries that ban pure white.',
  blog_general_passport_photo_background_rules_k4:
    'Keep lighting soft and symmetric to avoid halos and shadows.',

  blog_general_diy_passport_photos_at_home_title:
    'DIY Passport Photos at Home: Step-by-Step Guide Using Passlens',
  blog_general_diy_passport_photos_at_home_description:
    'Take professional-quality passport photos at home with your phone. This step-by-step guide covers lighting, camera setup, clothing, and how to edit and print using Passlens.',
  blog_general_diy_passport_photos_at_home_overview_p1:
    'You can take a compliant passport/ID photo at home with a phone if you control distance, lighting, and perspective.',
  blog_general_diy_passport_photos_at_home_overview_p2:
    'Passlens handles sizing, head guidance, and exports so you can focus on getting a clean, front-facing photo.',
  blog_general_diy_passport_photos_at_home_k1:
    'Use a neutral expression and look straight at the camera.',
  blog_general_diy_passport_photos_at_home_k2:
    'Stand a little away from the background to reduce shadows.',
  blog_general_diy_passport_photos_at_home_k3:
    'Avoid wide-angle distortion — use the main camera if possible.',
  blog_general_diy_passport_photos_at_home_k4:
    'Retake until eyes are sharp and there is no motion blur.',

  blog_general_digital_vs_printed_passport_photos_title:
    'Digital vs Printed Passport Photos: When You Need Each and How to Get Them Right',
  blog_general_digital_vs_printed_passport_photos_description:
    'Understand when you need a digital passport photo versus a printed one. Learn about file formats, resolution requirements, and how Passlens handles both formats.',
  blog_general_digital_vs_printed_passport_photos_overview_p1:
    'Some applications want a digital upload (pixels + file size limits). Others want printed photos in exact mm dimensions.',
  blog_general_digital_vs_printed_passport_photos_overview_p2:
    'Passlens supports both: export a properly sized PNG/JPEG for online forms or a print-ready sheet for cutting.',
  blog_general_digital_vs_printed_passport_photos_k1:
    'Digital specs often include pixel size and a max file size — check your application.',
  blog_general_digital_vs_printed_passport_photos_k2:
    'Printed photos must match physical dimensions; printer scaling is the common pitfall.',
  blog_general_digital_vs_printed_passport_photos_k3:
    'Background and head positioning rules apply to both.',
  blog_general_digital_vs_printed_passport_photos_k4:
    'Use consistent lighting and a high-resolution source photo.',

  blog_general_common_passport_photo_mistakes_title:
    '10 Common Passport Photo Mistakes That Cause Rejections (and How to Avoid Them)',
  blog_general_common_passport_photo_mistakes_description:
    'Learn the top 10 reasons passport photos are rejected: wrong size, bad background, shadows, glasses, and more. Fix these mistakes before you submit your application.',
  blog_general_common_passport_photo_mistakes_overview_p1:
    'Most rejections happen for the same reasons: wrong size, shadows, bad background, glasses glare, or a tilted head.',
  blog_general_common_passport_photo_mistakes_overview_p2:
    'Use a preset and verify basics before exporting to avoid delays.',
  blog_general_common_passport_photo_mistakes_k1:
    'Wrong dimensions (even a few mm) or incorrect head size.',
  blog_general_common_passport_photo_mistakes_k2:
    'Shadows, uneven lighting, or visible background texture.',
  blog_general_common_passport_photo_mistakes_k3:
    'Glasses, glare, or hair covering eyes.',
  blog_general_common_passport_photo_mistakes_k4:
    'Low resolution, blur, or heavy filters.',

  blog_general_baby_passport_photo_tips_title:
    'Baby Passport Photo Tips: How to Photograph Infants and Toddlers for Passports',
  blog_general_baby_passport_photo_tips_description:
    'Taking a passport photo of a baby or toddler is challenging. Learn how to position infants, keep their eyes open, hide your hands, and meet country-specific baby photo rules.',
  blog_general_baby_passport_photo_tips_overview_p1:
    'Baby passport photos are tricky because infants move, can’t hold a neutral expression, and need safe positioning.',
  blog_general_baby_passport_photo_tips_overview_p2:
    'Focus on sharp eyes, a clean background, and correct sizing — Passlens can handle the crop and export.',
  blog_general_baby_passport_photo_tips_k1:
    'Use soft, even light and avoid flash reflections.',
  blog_general_baby_passport_photo_tips_k2:
    'Lay the baby on a plain sheet or use a car seat with a plain cover.',
  blog_general_baby_passport_photo_tips_k3:
    'Keep hands and toys out of frame (or out of the final crop).',
  blog_general_baby_passport_photo_tips_k4:
    'Take many shots — you’ll usually need a few attempts.',

  blog_general_passport_photo_for_online_applications_title:
    'Digital Passport Photo Requirements 2026: Online Passport Photo Size, File Limits, and JPEG Upload Tips',
  blog_general_passport_photo_for_online_applications_description:
    'Digital passport photo requirements for online applications, including online passport photo size, passport photo upload requirements, JPEG file limits, and export settings that hold up on government portals.',
  blog_general_passport_photo_for_online_applications_overview_p1:
    'Online applications often have strict upload rules: pixel dimensions, file size limits, and JPEG/PNG formats.',
  blog_general_passport_photo_for_online_applications_overview_p2:
    'Passlens exports true pixel sizes at 300/600 DPI and helps you crop and align without uploading your image.',
  blog_general_passport_photo_for_online_applications_k1:
    'Use the correct preset so the crop matches official dimensions.',
  blog_general_passport_photo_for_online_applications_k2:
    'Check the upload portal for allowed formats and size limits.',
  blog_general_passport_photo_for_online_applications_k3:
    'Avoid compression that creates blocky artifacts around hair.',
  blog_general_passport_photo_for_online_applications_k4:
    'Keep background even and head centered.',

  landing_section_mobile_eyebrow: 'Native Apps',
  landing_section_mobile_title: 'Take your photos anywhere.',
  landing_section_mobile_body: 'Get Passlens on iPhone for the native camera, cleanup, and export flow. Android is still in development.',
  landing_mobile_ios: 'iOS',
  landing_mobile_ios_cta: 'Get iOS app',
  landing_mobile_android: 'Android',
  landing_mobile_coming_soon: 'Coming Soon',

  landing_section_ready_eyebrow: 'Ready to start',
  landing_section_ready_title: 'Make your first sheet in minutes.',

  footer_tagline: 'Made for accurate prints at 100% scale.',
  footer_copyright: '© {{year}} Passlens · 100% free · No signup · Local by default.',
  footer_affiliate_disclosure: 'This site may contain affiliate links. We may earn a commission if you buy through them, at no extra cost to you.',

  // Wizard / steps
  wizard_step_document_type: 'Document Type',
  wizard_step_upload_photos: 'Upload Photos',
  wizard_step_edit_crop: 'Edit & Crop',
  wizard_step_print_layout: 'Print Layout',
  wizard_step_short_document: 'Document',
  wizard_step_short_upload: 'Upload',
  wizard_step_short_edit: 'Edit',
  wizard_step_short_print: 'Print',
  wizard_need_help: 'Need help?',
  wizard_view_guide: 'View guide',
  wizard_send_feedback: 'Send feedback',

  wizard_tip_desktop: 'Tip: Passlens works best on desktop.',
  wizard_dismiss_tip: 'Dismiss tip',
  ios_app_splash_eyebrow: 'iPhone workflow',
  ios_app_splash_title: 'Passlens works best in the iOS app.',
  ios_app_splash_body:
    'Use the native app for the smoothest camera, cleanup, and export flow on iPhone. You can continue in the browser if you prefer.',
  ios_app_splash_open_app: 'Open iOS app',
  ios_app_splash_continue_web: 'Continue on web',
  ios_app_splash_dismiss: 'Dismiss iOS app recommendation',
  wizard_home: 'Home',
  wizard_progress_aria: 'Wizard progress',
  wizard_step_navigation_aria: 'Step navigation',
  wizard_prev_step: 'Previous step',
  wizard_next_step: 'Next step',
  wizard_go_to_step: 'Go to {{step}}',
  wizard_step_label: 'Step {{num}}',
  onboarding_hint_acknowledge: 'Got it',
  onboarding_hint_dismiss_aria: 'Dismiss hint',

  // Presets step
  preset_title: 'What document are you preparing?',
  preset_subtitle: 'Select your document type to get the correct photo dimensions',
  preset_search_placeholder: 'Search by country or document type...',
  preset_search_hint: 'Search for your country or document type',
  preset_custom_title: 'Custom',
  preset_custom_badge: 'DIY',
  preset_custom_size_title: 'Custom size',
  preset_custom_size_body: 'Enter dimensions for countries we don’t support yet',
  preset_custom_country_placeholder: 'Country (optional) e.g., BR',
  preset_custom_doc_label: 'Document',
  preset_custom_doc_passport: 'Passport',
  preset_custom_doc_photo_id: 'Photo ID',
  preset_custom_doc_visa: 'Visa',
  preset_custom_doc_other: 'Other',
  preset_custom_bg_label: 'Background',
  preset_custom_bg_white: 'White',
  preset_custom_bg_light: 'Light',
  preset_custom_width_placeholder: 'Width (mm)',
  preset_custom_height_placeholder: 'Height (mm)',
  preset_custom_head_min_placeholder: 'Head min (mm) (optional)',
  preset_custom_head_max_placeholder: 'Head max (mm) (optional)',
  preset_custom_use: 'Use custom preset',
  preset_no_results: 'No presets found for "{{query}}"',
  preset_jump_to_letter: 'Jump to letter',
  preset_mobile_sheet_title: 'Preset filters',
  preset_mobile_status: '{{count}} preset{{plural}}',
  preset_mobile_search_title: 'Search presets',
  preset_mobile_search_placeholder: 'Country, document, or code…',
  preset_mobile_tip: 'Tip: try “US passport” or “UK”.',
  preset_us_state_help_title: '{{state}} usually stays in the DMV photo lane',
  preset_us_state_help_body:
    'For most U.S. states, the driver license, state ID, or REAL ID photo is either taken at the office or reused from the DMV record. Use the state guide before assuming you need a printable preset.',
  preset_us_state_help_cta: 'Open the U.S. state guide',
  preset_country_help_title_doc: 'We do not have a verified {{doc}} preset for {{country}} yet',
  preset_country_help_title_country: 'We do not have a verified preset for {{country}} yet',
  preset_country_help_body_supported:
    'Passlens already supports {{supportedDocs}} for {{country}}, but this search does not map to a verified preset yet.',
  preset_country_help_body_none:
    'Passlens does not have a verified country preset for {{country}} yet.',
  preset_country_help_body_verify:
    'Open the requirement guide first and only fall back to a custom preset if the authority clearly accepts a self-prepared photo and you can match the official size and upload rules.',
  preset_country_help_guides_label: 'Available verified guides:',
  preset_country_help_cta: 'Open the requirement guide',
  preset_unverified: 'Unverified',

  preset_error_invalid_mm: 'Enter a valid width and height in millimeters.',
  preset_error_mm_range: 'Use dimensions between 10mm and 100mm.',
  preset_error_head_both: 'Enter both head min and max, or leave them blank.',
  preset_error_head_order: 'Head min must be smaller than head max.',
  preset_error_head_within: 'Head max must be within the photo height.',

  // Upload step
  upload_title: 'Add your photos',
  upload_drop_title: 'Drop photos here',
  upload_drop_subtitle: 'or click to browse',
  upload_choose_files: 'Choose files',
  upload_take_photo: 'Take a photo',
  upload_add_more: 'Add more',
  upload_drop_more: 'Drop more photos here',
  upload_controls_title: 'Upload controls',
  upload_tips_title: 'Tips',
  upload_tip_1: 'Use a clear, front-facing photo.',
  upload_tip_2: 'Avoid heavy shadows and harsh lighting.',
  upload_tip_3: 'We process everything locally in your browser.',
  upload_selected_preset_title: 'Selected preset',
  upload_photo_alt: 'Uploaded photo',
  upload_photo_status_edited: 'Edited',
  upload_photo_status_needs_edit: 'Needs edit',

  // Edit step
  edit_empty_no_photos: 'No photos to edit',
  edit_page_title: 'Crop & Edit',
  edit_download_photo: 'Download exact photo',
  edit_download_photo_png: 'Download exact PNG',
  edit_download_photo_jpeg: 'Download exact JPEG',
  edit_digital_export_note_title: 'Digital upload file available.',
  edit_digital_export_note_body:
    'The print download stays at {{w}}×{{h}} mm ({{pxW}}×{{pxH}} px at {{dpi}} DPI). Use the digital export when an online form asks for fixed pixel dimensions.',
  edit_digital_export_note_link: 'Digital photo rules',
  edit_digital_export_download: 'Download {{w}}×{{h}} {{format}}',
  edit_digital_export_max_size: 'Maximum file size: {{size}} KB.',
  edit_digital_export_size_error:
    'Passlens could not create a JPEG within the {{size}} KB limit. Try another clear photo with a plain background.',
  edit_digital_export_download_hint:
    'Open the file and check it in the official service before submitting.',
  edit_download_direct_title: 'Need only the exact photo?',
  edit_download_direct_body:
    'Use {{button}} here. Continue to {{step}} only if you want a print sheet or a multi-photo page.',
  edit_download_direct_mobile: 'Only need the photo? Use {{button}}.',
  edit_photo_counter: 'Photo {{current}} of {{total}}',
  edit_photo_done_suffix: '({{count}} done)',
  edit_preset_summary: '{{doc}} · {{w}}×{{h}}mm · {{dpi}} DPI{{px}}',
  edit_preset_px_suffix: ' ({{w}}×{{h}}px)',
  edit_preset_background: 'Background: {{bg}}{{note}}',
  edit_onboarding_autofit:
    'Click "{{button}}" to detect your face, crop, straighten, and remove the background automatically',
  edit_preview_alt: 'Photo preview',
  edit_hint: 'Tip: drag to position · scroll to zoom · right-click to reset the view.',

  edit_auto_title: 'Auto',
  edit_auto_button_ready: 'Auto Create Compliant Photo',
  edit_bg_edit_warning_title: 'Keep your real background',
  edit_bg_edit_warning_body:
    'For U.S. passport photos, the State Department doesn’t accept backgrounds edited with software, apps, filters, or AI. Auto-comply straightens, crops, and sizes your photo but keeps your original background — so shoot against a plain white wall with even lighting.',
  edit_auto_button_preparing: 'Auto setup is loading, please wait.',
  edit_auto_description:
    'Detects your face, straightens tilt, crops to spec, and removes the background — all in one click.',
  edit_auto_description_no_bg:
    'Detects your face, straightens tilt, and crops to spec — all in one click. Your original background is kept.',
  edit_onboarding_autofit_no_bg:
    'Click "{{button}}" to detect your face, crop, and straighten automatically. Your original background is kept.',
  edit_action_plan_title: 'Fastest way through Edit',
  edit_action_plan_intro: 'Most people move faster when they do these steps in order.',
  edit_action_plan_step_autofit: 'Start with {{action}} to get the crop and head position close.',
  edit_action_plan_step_background: 'If the wall or lighting still looks wrong, run {{action}} next.',
  edit_action_plan_step_download: 'Use {{action}} when you only need the exact file.',
  edit_action_plan_step_continue: 'Use {{action}} after every photo is saved and you want the print layout.',
  edit_action_plan_note_default: 'Check the overlay before you save. The final image still needs a quick human review.',
  edit_action_plan_note_custom:
    'Custom presets need one extra check. Confirm the size and head range before you save.',
  edit_action_plan_note_head_range:
    'This preset is stricter about head height. Let auto fit get close, then verify the overlay before you save.',
  edit_action_plan_note_be_photo_id:
    'For this ID photo, keep the face centered and avoid trimming the shoulders too tightly.',
  edit_auto_step_detect_face: 'Detect face',
  edit_auto_step_crop_align: 'Align crop',
  edit_auto_step_remove_bg: 'Remove background',
  edit_auto_step_finalize: 'Finalize',

  edit_autofit_preparing: 'Preparing auto fit…',
  edit_autofit_download_progress_aria: 'Auto fit setup download progress',
  edit_autofit_progress_aria: 'Auto fit progress',
  edit_autofit_failed_to_load: 'Failed to load Auto fit.',
  edit_autofit_headtop_aria: 'Auto fit head top point',
  edit_autofit_chin_aria: 'Auto fit chin point',

  edit_hq_preparing: 'Preparing high-quality background removal…',
  edit_hq_download_progress_aria: 'High-quality setup download progress',
  edit_hq_failed_to_load: 'Failed to load high-quality background removal.',
  edit_birefnet_failed_to_load: 'Failed to load enhanced local processing.',
  edit_model_download_autofit_title: 'Auto fit setup',
  edit_model_download_hq_title: 'High-quality setup',
  edit_model_download_birefnet_title: 'Enhanced local setup',
  edit_model_download_phase_downloading: 'Downloading',
  edit_model_download_phase_initializing: 'Initializing',
  edit_model_download_loaded_of_total: '{{loaded}} / {{total}}',
  edit_model_download_loaded_only: '{{loaded}} downloaded',
  edit_model_download_remaining: '{{remaining}} left',

  edit_retry_download: 'Retry download',

  edit_preload_title: 'Setup is loading',
  edit_preload_autofit_label: 'Loading Auto fit, please wait.',
  edit_preload_bg_label: 'Loading background removal, please wait.',
  edit_preload_birefnet_label: 'Loading enhanced local processing, please wait.',
  edit_preload_generic_label: 'Setup is loading, please wait.',

  edit_guides_aria: 'Head guide overlay',
  edit_headtop_label: 'Head top',
  edit_chin_label: 'Chin',
  edit_framing_head_label: 'Keep full head in frame',
  edit_framing_shoulders_label: 'Keep neck and shoulders visible',

  edit_overlay_title_preparing: 'Auto fit',
  edit_overlay_title_removing_bg: 'Removing background',
  edit_overlay_title_exporting: 'Exporting',
  edit_overlay_title_saving: 'Saving',
  edit_overlay_label_rendering: 'Rendering…',
  edit_overlay_label_rendering_image: 'Rendering image…',

  edit_progress_starting: 'Starting…',
  edit_progress_loading_photo: 'Loading photo…',
  edit_progress_detecting_face: 'Detecting face…',
  edit_progress_analyzing_bg: 'Analyzing background…',
  edit_progress_detecting_headtop: 'Detecting head top…',
  edit_progress_aligning_crop: 'Aligning crop…',
  edit_progress_preparing_image: 'Preparing image…',
  edit_progress_preparing_hq_model: 'Preparing high-quality background removal…',
  edit_progress_preparing_birefnet_model: 'Preparing enhanced local processing…',
  edit_progress_removing_bg: 'Removing background…',
  edit_progress_applying_mask: 'Applying mask…',
  edit_progress_done: 'Done',

  edit_error_load_photo_failed: 'Could not load the photo. Please try again.',
  edit_error_no_face_detected: 'No face detected. Try a clearer portrait photo or adjust manually.',
  edit_error_face_detection_timeout: 'Face detection timed out. Please try again.',
  edit_error_headtop_not_found: 'Could not find the top of the head. Try a clearer photo or adjust manually.',
  edit_error_headtop_timeout: 'Head-top detection timed out. Please try again.',
  edit_error_hq_preload_timeout: 'High-quality background removal setup timed out. Please retry.',
  edit_error_hq_preload_failed: 'Could not prepare high-quality background removal. Please retry.',
  edit_error_hq_model_download_timeout: 'High-quality background removal setup timed out. Please retry.',
  edit_error_hq_bg_timeout: 'Background removal timed out. Please try again.',
  edit_error_birefnet_preload_timeout: 'Enhanced local setup timed out. Please retry.',
  edit_error_birefnet_preload_failed: 'Could not prepare enhanced local processing. Please retry.',
  edit_error_birefnet_model_download_timeout: 'Enhanced local setup timed out. Please retry.',
  edit_error_birefnet_bg_timeout: 'Enhanced local processing timed out. Please try again.',
  edit_error_birefnet_memory_failed:
    'Enhanced local processing needs more browser memory on this device. Use Standard local or Passlens enhanced processing for this photo.',
  edit_error_autofit_preload_timeout: 'Auto fit setup timed out. Please retry.',
  edit_error_autofit_preload_failed: 'Failed to preload Auto fit.',
  edit_error_auto_mode_failed: 'Auto fit failed. Please try again.',

  edit_bg_task_title: 'Removing background',
  edit_bg_error_generic: 'Background removal failed. Please try again.',
  edit_bg_error_hq: 'High-quality background removal failed. Please try again.',
  edit_toast_bg_removed: 'Background removed.',
  edit_toast_photo_saved: 'Photo saved.',
  edit_toast_save_failed: 'Save failed. Please try again.',

  edit_resolution_title: 'Resolution',
  edit_transform_title: 'Transform',
  edit_rotation_label: 'Rotation',
  edit_rotate_minus_15_title: 'Rotate -15°',
  edit_rotate_plus_15_title: 'Rotate +15°',
  edit_zoom_label: 'Zoom',
  edit_zoom_out_title: 'Zoom out',
  edit_zoom_in_title: 'Zoom in',
  edit_reset_zoom_title: 'Reset zoom',
  edit_auto_fit_zoom_on_rotate: 'Auto-fit zoom on rotate',

  edit_background_title: 'Background',
  edit_bg_mode_keep_original: 'Keep original',
  edit_bg_mode_fast: 'Fast removal (uniform)',
  edit_bg_mode_hq: 'High-quality (advanced)',
  edit_processing_location_label: 'Run on',
  edit_processing_location_local: 'On this device',
  edit_processing_location_server: 'Use Passlens enhanced processing',
  edit_local_processing_auto_description:
    'Private on-device processing. Passlens only downloads the required setup when you choose the local path.',
  edit_server_processing_auto_description:
    'Use Passlens enhanced processing if your device is slow or local setup is taking too long.',
  edit_local_processing_bg_description:
    'Keep background removal on this device. Fast removal works without downloads; high-quality removal may need a one-time local setup.',
  edit_server_processing_bg_description:
    'Use Passlens enhanced processing for background cleanup if your device is slow or local processing is taking too long.',
  edit_bg_button_remove: 'Remove background',
  edit_bg_button_removing: 'Removing…',
  edit_bg_button_preparing_model: 'Setup is loading, please wait.',
  edit_bg_progress_aria: 'Background removal progress',
  edit_bg_reset: 'Reset background',
  server_processing_beta_badge: 'Enhanced option',
  server_processing_beta_title: 'Enhanced processing',
  server_processing_beta_body:
    'Passlens can handle background removal and auto fit with enhanced processing when local setup or processing on your device is taking too long.',
  server_processing_beta_privacy:
    'Using the enhanced option uploads the current photo to Passlens for this request.',
  server_processing_beta_bg: 'Enhanced background removal',
  server_processing_beta_autofit: 'Enhanced auto fit',
  server_processing_beta_toast:
    'Enhanced processing is unavailable right now. Please try again.',
  server_processing_status_uploading: 'Uploading image for processing…',
  server_processing_status_queued: 'Preparing preview…',
  server_processing_status_ready: 'Preview ready.',
  server_processing_beta_preview_failed: 'Enhanced processing failed. Please try again.',
  server_processing_preview_alt: 'Enhanced processing preview',
  server_processing_preview_apply: 'Apply preview',
  server_processing_preview_discard: 'Discard preview',
  server_processing_preview_apply_done: 'Preview applied.',
  local_processing_assist_download_title: '{{operation}} setup is taking longer than expected',
  local_processing_assist_download_body:
    'Your device is still preparing the local run. You can keep waiting locally, or cancel the local attempt and switch to enhanced processing.',
  local_processing_assist_download_body_local_only:
    'Your device is still preparing the local run. Keep waiting on this device to finish the local-only run.',
  local_processing_assist_processing_title: '{{operation}} is taking longer than expected',
  local_processing_assist_processing_body:
    'Local processing is still running. You can keep waiting on this device, or cancel the local attempt and switch to enhanced processing.',
  local_processing_assist_processing_body_local_only:
    'Local processing is still running. Keep waiting on this device to finish the local-only run.',
  local_processing_assist_server_note:
    'Choosing enhanced processing cancels the local attempt for this action.',
  local_processing_assist_keep_waiting: 'Keep waiting on this device',
  local_processing_assist_use_enhanced_local: 'Try Enhanced local',
  local_processing_assist_use_server: 'Use enhanced processing instead',
  local_processing_assist_server_started: 'Enhanced processing started. Local processing was cancelled.',
  processing_choice_prompt_title: 'Choose how to run {{operation}}',
  processing_choice_prompt_body:
    'Choose a local option for this run, or use Passlens enhanced processing if you want us to handle the heavier work.',
  processing_choice_background_frame_note:
    'For background removal, only the visible photo area inside the frame is processed. Anything outside the frame is left out of this action.',
  processing_choice_fast_local_title: 'Standard local',
  processing_choice_fast_local_body:
    'Downloads about 25 MB, then runs {{operation}} in this browser. Nothing is uploaded.',
  processing_choice_enhanced_local_title: 'Enhanced local',
  processing_choice_enhanced_local_body:
    'Downloads about {{size}}, then runs a more detailed local cleanup in this browser. Nothing is uploaded.',
  processing_choice_enhanced_local_checking_body:
    'Checking whether this browser can run Enhanced local.',
  processing_choice_enhanced_local_browser_body:
    'This browser cannot run Enhanced local on this page.',
  processing_choice_enhanced_local_adapter_body:
    'This browser did not return a usable graphics adapter. Fully quit Chrome and relaunch it with hardware acceleration enabled.',
  processing_choice_enhanced_local_software_body:
    'This browser only returned a software graphics adapter, so Enhanced local stays off.',
  processing_choice_enhanced_local_device_body:
    'This browser could not initialize Enhanced local.',
  processing_choice_enhanced_local_buffers_body:
    'This device does not expose enough graphics capacity for Enhanced local.',
  processing_choice_enhanced_local_memory_body:
    'This device reports {{memory}} GB of memory. Enhanced local needs at least {{required}} GB.',
  processing_choice_enhanced_local_mobile_memory_body:
    'This mobile browser does not report enough memory for Enhanced local.',
  processing_choice_enhanced_local_runtime_body:
    'This browser cannot run Enhanced local right now.',
  processing_choice_enhanced_local_session_body:
    'Enhanced local failed earlier in this tab. Passlens will use the safer local path for this run.',
  processing_choice_local_title: 'On this device',
  processing_choice_local_body:
    'Downloads about 25 MB, then runs {{operation}} in this browser. Nothing is uploaded.',
  processing_choice_server_title: 'Use Passlens enhanced processing',
  processing_choice_server_body:
    'A temporary copy is sent to Passlens so the heavy part can finish faster. It is processed in memory for this request and cleared right after.',
  processing_choice_server_note:
    'Passlens does not keep the image from this shortcut. It is used only to finish this request.',
  processing_choice_recommended: 'Recommended',
  processing_choice_chip_on_device: 'On device',
  processing_choice_chip_cloud: 'Online',
  processing_choice_chip_fast: 'Fast',
  processing_choice_chip_checking: 'Checking',
  processing_choice_chip_unavailable: 'Unavailable',
  processing_choice_chip_best_quality: 'Best quality',
  processing_choice_chip_heavy_work: 'Fastest',

  edit_bg_color_white: 'White',
  edit_bg_color_offwhite: 'Off-white',
  edit_bg_color_lightblue: 'Light blue',
  edit_bg_color_lightgray: 'Light gray',

  edit_border_title: 'Border',
  edit_border_add: 'Add border',
  edit_border_width: 'Width',
  edit_border_match_background: 'Match background',

  edit_outline_title: 'Outline',
  edit_outline_hairline: '1px hairline outline',

  edit_guidance_title: 'Guidance',
  edit_guidance_compliance_overlay: 'Compliance overlay',
  edit_guidance_helper: 'Shows acceptable head height range',
  edit_guidance_official_title: 'Official framing guidance',
  edit_guidance_sources_title: 'Official sources',

  edit_shortcuts_title: 'Keyboard Shortcuts',
  edit_shortcut_save_proceed: 'Save/Proceed',
  edit_shortcut_download_png: 'Download PNG',
  edit_shortcut_dpi: 'DPI',
  edit_shortcut_rotate: 'Rotate ±15°',
  edit_shortcut_zoom: 'Zoom ±0.2',
  edit_shortcut_toggle_overlay: 'Toggle overlay',
  edit_shortcut_reset_viewport: 'Reset viewport',

  edit_mobile_controls_title: 'Edit controls',
  edit_mobile_sections_aria: 'Edit controls sections',
  edit_mobile_actions_aria: 'Edit actions',
  edit_mobile_download_button: 'Download',
  edit_mobile_download_modal_title: 'Choose download format',
  edit_mobile_download_modal_body: 'Use PNG when the site accepts it or you want the cleanest file. Use JPEG/JPG when the form asks for it or needs a smaller file.',
  edit_mobile_download_png_action: 'Download PNG',
  edit_mobile_download_png_hint: 'Clean, lossless export for uploads that accept PNG.',
  edit_mobile_download_jpeg_action: 'Download JPEG',
  edit_mobile_download_jpeg_hint: 'Smaller file for services that ask for JPG or JPEG.',
  edit_mobile_download_cancel: 'Cancel',
  edit_mobile_download_close_aria: 'Close download options',
  edit_mobile_action_auto_comply: 'Auto',
  edit_mobile_tab_auto: 'Auto',
  edit_mobile_tab_dpi: 'DPI',
  edit_mobile_tab_guides: 'Guides',

  edit_save_hint: 'Save to continue to {{step}}',
  edit_reset_all: 'Reset All',
  edit_skip_photo_title: 'Skip photo',

  // Compose / Print Layout step
  compose_empty_select_preset: 'Please select a preset first',
  compose_subtitle: 'Arrange your photos for printing · Drag to reposition',
  compose_onboarding_export: 'Export your sheet as PDF or PNG when ready',
  compose_print_warning_banner: 'Print at 100% scale (no fit-to-page) for accurate photo dimensions',
  compose_toast_print_warning: 'Print at 100% scale (no fit-to-page) for accurate sizes',

  compose_photos_title: 'Photos',
  compose_select_all: 'Select all',
  compose_select_photo_aria: 'Select photo {{index}} for the print sheet',
  compose_not_edited: 'Not edited',
  compose_copies_label: 'Copies',
  compose_copies_controls_aria: 'Copies controls for photo {{index}}',
  compose_copies_decrease_aria: 'Decrease copies for photo {{index}}',
  compose_copies_increase_aria: 'Increase copies for photo {{index}}',
  compose_copies_for_photo_aria: 'Copies for photo {{index}}',
  compose_copies_decrease_title: 'Decrease copies',
  compose_copies_increase_title: 'Increase copies',
  compose_copies_title: 'Copies',

  compose_warning_edit_one: 'Please edit at least one photo',
  compose_warning_select_one: 'Please select at least one photo',

  compose_undo_title: 'Undo (Ctrl+Z)',
  compose_redo_title: 'Redo (Ctrl+Y)',
  compose_undo_short: 'Undo',
  compose_redo_short: 'Redo',
  compose_reset_layout_title: 'Reset layout',

  compose_grid_info_mobile: 'Page {{page}}/{{pages}} · {{placed}}/{{total}} · {{dpi}} DPI{{requested}}',
  compose_grid_info_desktop:
    'Fits {{fits}} ({{cols}}×{{rows}}) · Page {{page}}/{{pages}} · {{placed}} placed · {{total}} total · {{dpi}} DPI{{requested}}',
  compose_grid_info_requested_suffix: ' ({{requested}} requested)',

  compose_prev_page_title: 'Previous page',
  compose_next_page_title: 'Next page',

  compose_warning_no_capacity:
    'Margin/spacing/paper are too tight — no photos fit. Reduce margins or spacing, or choose a larger paper size.',
  compose_warning_copies_over_limit:
    'Requested {{requested}} copies, but the maximum is {{max}}. Reduce copies to enable export.',

  compose_pages_title: 'Pages',
  compose_pages_aria: 'Pages',
  compose_page_aria: 'Page {{page}}',
  compose_page_label: 'Page {{page}}/{{pages}}',
  compose_page_pill: 'Pg {{page}}/{{pages}} · {{placed}}/{{total}} · {{dpi}} DPI',

  compose_preview_title: 'Preview',
  compose_preview_zoom_label: 'Preview zoom',
  compose_preview_fit: 'Fit',
  compose_preview_fit_title: 'Fit preview to screen',

  compose_paper_size_title: 'Paper Size',
  compose_custom_paper_unit_label: 'Units',
  compose_custom_paper_unit_aria: 'Custom paper units',
  compose_custom_paper_unit_mm: 'Millimetres',
  compose_custom_paper_unit_cm: 'Centimetres',
  compose_custom_paper_unit_in: 'Inches',
  compose_custom_paper_width_label: 'Width',
  compose_custom_paper_height_label: 'Height',
  compose_custom_paper_width_aria: 'Custom paper width',
  compose_custom_paper_height_aria: 'Custom paper height',
  compose_custom_paper_hint: 'Choose the unit, then enter the sheet size.',
  compose_layout_title: 'Layout',
  compose_layout_preset_label: 'Layout preset',

  compose_layout_auto_name: 'Auto grid',
  compose_layout_auto_desc: 'Fill the sheet with as many copies as fit using default margins.',
  compose_layout_auto_rotated_name: 'Auto grid (rotated)',
  compose_layout_auto_rotated_desc: 'Rotate every copy 90° to fit more photos on the sheet.',
  compose_layout_single_name: 'Single centered',
  compose_layout_single_desc: 'Place one photo centered on the page.',
  compose_layout_single_rotated_name: 'Single centered (rotated)',
  compose_layout_single_rotated_desc: 'Rotate the photo 90° and center it on the page.',
  compose_layout_custom_desc: 'Using your own margins, spacing, and copy count.',
  compose_layout_custom_tip: 'Choose Custom if you want separate copy counts for each photo or your own spacing.',

  compose_margin_label: 'Margin',
  compose_spacing_label: 'Spacing',
  compose_margin_decrease_title: 'Decrease margin (-)',
  compose_margin_increase_title: 'Increase margin (+)',
  compose_spacing_decrease_title: 'Decrease spacing ([)',
  compose_spacing_increase_title: 'Increase spacing (])',

  compose_total_copies_label: 'Total copies',
  compose_total_copies_aria: 'Total copies',
  compose_copies_decrease_total_title: 'Fewer copies (<)',
  compose_copies_increase_total_title: 'More copies (>)',

  compose_copies_mode_label: 'Copies mode',
  compose_copies_mode_total: 'Total',
  compose_copies_mode_per_photo: 'Per photo',
  compose_copies_mode_hint: 'Set copies next to each selected photo.',

  compose_rotation_label: 'Rotation',
  compose_rotate_selected_minus_90_title: 'Rotate selected -90° (Q)',
  compose_rotate_selected_minus_90_aria: 'Rotate selected -90°',
  compose_rotate_selected_plus_90_title: 'Rotate selected +90° (E)',
  compose_rotate_selected_plus_90_aria: 'Rotate selected +90°',
  compose_reset_selected_rotation_title: 'Reset selected rotation (0)',
  compose_reset_selected_rotation_aria: 'Reset selected rotation',
  compose_rotation_hint_desktop: 'Click a photo in the preview to select it · Q/E rotate · 0 reset',
  compose_rotation_hint_mobile: 'Tap a photo in the preview to select it · Q/E rotate · 0 reset',

  compose_use_custom_layout_label: 'Use custom layout in export',
  compose_use_custom_layout_disabled_title:
    'Drag or rotate photos in the preview to customize layout before exporting',

  compose_export_options_title: 'Export Options',
  compose_crop_marks_label: 'Crop marks',
  compose_paper_label_toggle: "Print paper size",
  compose_paper_label_no_space: "No room for the paper-size label on page {{page}}. Increase the margin, move a photo, or turn off Print paper size.",
  compose_paper_label_error: "The paper-size label could not be prepared. Try again or turn off Print paper size.",
  compose_sheet_export_dpi_label: 'Sheet export DPI',
  compose_sheet_export_dpi_aria: 'Sheet export DPI',
  compose_sheet_export_dpi_auto: 'Auto',
  compose_sheet_export_dpi_300: '300 DPI',
  compose_sheet_export_dpi_600: '600 DPI',
  compose_export_note_multipage:
    'PNG and JPEG export the current page at {{dpi}} DPI. Use the ZIP buttons or PDF for all pages.',
  compose_export_note_singlepage: 'Sheet PNG and JPEG exports use {{dpi}} DPI.',
  compose_export_warning_mixed_dpi:
    'Mixed photo DPI ({{dpis}}). Auto uses {{dpi}} DPI so lower-DPI photos are not upscaled.',
  compose_export_warning_upscale:
    'This sheet exports at {{dpi}} DPI, but at least one photo was saved at {{photoDpi}} DPI. The sheet and crop marks get more pixels; photo detail may not.',

  compose_download_png_page: 'Download PNG (Page {{page}})',
  compose_download_jpeg_page: 'Download JPEG (Page {{page}})',

  compose_mobile_controls_title: 'Print controls',
  compose_mobile_sections_aria: 'Print controls sections',
  compose_mobile_tab_photos: 'Photos',
  compose_mobile_tab_paper: 'Paper',
  compose_mobile_tab_layout: 'Layout',
  compose_mobile_tab_export: 'Export',
  compose_mobile_tab_preview: 'Preview',

  compose_toast_png_exported: 'PNG exported',
  compose_toast_png_export_failed: 'PNG export failed',
  compose_toast_pngs_zip_exported: 'PNGs exported as ZIP',
  compose_toast_jpeg_exported: 'JPEG exported',
  compose_toast_jpeg_export_failed: 'JPEG export failed',
  compose_toast_jpegs_zip_exported: 'JPEGs exported as ZIP',
  compose_toast_zip_export_failed: 'ZIP export failed',
  compose_toast_pdf_exported: 'PDF exported',
  compose_toast_pdf_export_failed: 'PDF export failed',

  // Contact form
  contact_title_contact: 'Send us a message',
  contact_title_support: 'Ask for help',
  contact_kind_contact: 'Contact',
  contact_kind_support: 'Support',
  contact_mode_aria: 'Message type',
  contact_honeypot_label: 'Website',
  contact_name_label: 'Name (optional)',
  contact_name_placeholder: 'Your name',
  contact_name_aria: 'Name',
  contact_email_label: 'Email',
  contact_email_placeholder: 'you@example.com',
  contact_email_aria: 'Email',
  contact_message_aria: 'Message',
  contact_message_placeholder_support: 'Tell us what happened and what you expected…',
  contact_message_placeholder_contact: 'How can we help?',
  contact_submit_sending: 'Sending…',
  contact_submit_send: 'Send message',
  contact_sent: 'Message sent. We’ll reply by email.',

  contact_error_rate_limited: 'Too many messages. Please try again in a minute.',
  contact_error_forbidden_origin: 'This form can only be used from the Passlens website.',
  contact_error_invalid_body: 'Please enter a valid email and a message.',
  contact_error_unsupported_media_type: 'Could not send your message. Please refresh and try again.',
  contact_error_spam_detected: 'Please remove the website field and try again.',
  contact_error_captcha_required: 'Please complete the captcha to send your message.',
  contact_error_captcha_invalid: 'Captcha failed. Please try again.',
  contact_error_captcha_unavailable: 'Spam protection is unavailable right now. Please try again later.',
  contact_error_email_disabled: 'Email is temporarily unavailable. Please try again later.',
  contact_error_email_misconfigured: 'Email is not configured yet. Please try again later.',
  contact_error_attachment_invalid_type: 'Only image attachments are allowed.',
  contact_error_attachment_too_large: 'Image attachments must be 500 KB or smaller.',
  contact_error_attachment_invalid_data: 'The image attachment could not be processed. Please try another file.',
  contact_error_generic: 'Could not send your message. Please try again.',
  feedback_title: 'How was Passlens?',
  feedback_body: 'You just exported your photo. Rate the experience, then tell us what worked and what got in the way.',
  feedback_title_abandon: 'Before you go, was something missing?',
  feedback_body_abandon: 'If something got in the way, tell us. We read these notes and use them to improve Passlens.',
  feedback_nudge_title: 'Need help getting the result you want?',
  feedback_nudge_body: 'If something felt confusing or off, send a quick note here.',
  feedback_nudge_cta: 'Send feedback',
  feedback_rating_label: 'Your rating',
  feedback_message_label: 'Feedback (optional)',
  feedback_email_label: 'Email (optional)',
  feedback_email_placeholder: 'you@example.com',
  feedback_email_helper: 'Optional. Add your email only if you want a reply about this feedback.',
  feedback_message_placeholder: 'What worked? What got in the way? What should we change?',
  feedback_submit: 'Send feedback',
  feedback_leave_cta: 'Leave feedback',
  feedback_submit_sending: 'Sending feedback…',
  feedback_not_now: 'Not now',
  feedback_sent: 'Thanks. Your feedback was sent.',
  feedback_error_invalid_email: 'Enter a valid email or leave the field blank.',
  feedback_error_generic: 'Could not send your feedback. Please try again.',
  feedback_star_aria: 'Rate {{count}} out of 5',
  feedback_close_aria: 'Close feedback dialog',
  feedback_thanks_title: 'Thanks for the feedback.',
  feedback_thanks_body: 'We read every note and use it to improve Passlens.',
  donate_title: 'Chip in $1 to keep Passlens free',
  donate_body:
    'Passlens can save you a trip to the photo shop and keeps the core tools private in your browser. If it helped, a small donation keeps the site free for the next person.',
  donate_body_after_export: 'Your download has started. Payment is optional.',
  donate_body_manual: 'Payment is optional. Passlens remains free to use.',
  donate_cadence_label: 'Donation frequency',
  donate_cadence_one_time: 'One-time',
  donate_cadence_monthly: 'Monthly',
  donate_feedback_title: 'This export is ready',
  donate_feedback_body: 'If it saved you time, $1 helps keep Passlens free and private for the next person.',
  donate_presets_label: 'Quick amounts',
  donate_amount_label: 'Choose an amount',
  donate_custom_amount_label: 'Custom amount',
  donate_custom_amount_placeholder: '1',
  donate_custom_amount_helper: 'Enter a whole-dollar amount between $1 and $1,000.',
  donate_custom_amount_error: 'Enter a whole-dollar amount between $1 and $1,000.',
  donate_custom_amount_helper_monthly: 'Enter a whole-dollar monthly amount between $1 and $100.',
  donate_custom_amount_error_monthly: 'Enter a whole-dollar monthly amount between $1 and $100.',
  donate_monthly_disclosure:
    '{{amount}} will be charged today and every month until you cancel. Cancel anytime in the secure billing portal.',
  donate_monthly_button: 'Support Passlens with {{amount}}/month',
  donate_button: 'Donate',
  donate_button_opening: 'Opening…',
  donate_error_generic: 'Could not start donation checkout. Please try again.',
  donate_return_success: 'Thank you for supporting Passlens.',
  donate_return_success_monthly: 'Your monthly support is active. Thank you for supporting Passlens.',
  donate_return_verifying: 'Checking your support payment…',
  donate_return_pending: 'Your payment is still processing. We’ll keep checking for a moment.',
  donate_return_failed: 'We could not verify that payment. Passlens is still free to use.',
  donate_return_cancelled: 'Donation cancelled.',
  donate_return_close_aria: 'Dismiss donation message',
  donate_manage_monthly: 'Manage monthly support',
  support_modal_body:
    'Passlens stays free, private, and independent. If it saves you time or replaces a photo-shop trip, a small donation helps keep the site open without ads or tracking.',
  support_modal_note: 'Every donation is optional. It helps keep Passlens free for everyone.',
  support_modal_close_aria: 'Close support modal',
  donate_dev_title: 'Stripe sandbox',
  donate_dev_body: 'Dev-only checkout launcher using the configured Stripe sandbox keys.',
  donate_dev_button: 'Donate {{amount}}',
  donate_dev_error: 'Donation checkout failed: {{error}}',
  // Captcha
  captcha_label: 'Spam protection',
  captcha_im_human: 'I’m human',
  captcha_unavailable_short: 'Spam protection is unavailable right now.',
  captcha_unavailable_reload: 'Spam protection is unavailable right now. Please reload and try again.',
  captcha_not_available: 'Spam protection is not available right now.',
  captcha_unavailable_button: 'Captcha unavailable',
} as const;
